<script>
export default {
  props: ["title", "modelValue", "type"],
  name: "FilterInput",
  emits: ["update:modelValue"],
};
</script>

<template>
  <div class="filter">
    <label class="title">{{ title }}:</label>
    <input class="input control" :type="type" :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)" />
  </div>
</template>